import CONFIG from './config.json'

export const GLOBAL_CONFIG = CONFIG
